import React, {useState } from 'react'
import PriceForm from './price-form'
import { PriceCalculateScreenV2 } from "~common/price-calculate-screen-v2";
import { OnlinepbxLoader } from '@onpbx/onlinepbx-components'
import { QualityControl } from "~/components/pages/price/components/quality-control";
import { QuestionsScreen } from "~common/questions-screen";
import { StoringCalls } from "~/components/pages/price/components/storing-calls";
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import { Analytics } from "~/components/pages/price/components/analytics";
import { priceService } from "~/store/price/price-service";
import { IPrice } from "~/types/IPrice";

export const Price: React.FC = () => {
  const [isLegalPerson, setIsLegalPerson] = useState(false);
  const { data: services, isLoading } = priceService.useGetPricesQuery('');

  const getServicePrice = (type: string) => {
     return services?.find((service: IPrice) => service.type === type)
  }

  return (
    isLoading
      ? <OnlinepbxLoader/>
      : <>
      <Styled.PriceWrapp>
        <PriceCalculateScreenV2
          services={services}
          isLegalPerson={isLegalPerson}
          setIsLegalPerson={setIsLegalPerson}
          screenProps={{ bottomLine: true, title: <span><StyledScreen.GreenText>Сколько стоит</StyledScreen.GreenText> onlinepbx</span>}}
          style={{ paddingBottom: '37px' }}
        />
      </Styled.PriceWrapp>
      <PriceForm />
      <Styled.TitleContainer>
        <Styled.Title>Дополнительные <StyledScreen.GreenText>возможности</StyledScreen.GreenText></Styled.Title>
      </Styled.TitleContainer>
      <StoringCalls service={getServicePrice('RECORDS')} stereoService={getServicePrice('STEREO_RECORDS')} isLegalPerson={isLegalPerson} />
      <QualityControl service={getServicePrice('QUALITY_SCORE')} isLegalPerson={isLegalPerson} />
      <Analytics service={getServicePrice('ANALYTICS')}  isLegalPerson={isLegalPerson}  />
      <QuestionsScreen screenProps={{ bottomLine: false }} />
    </>
  )
}

export default Price
